import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07e35ea0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=07e35ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountHeader: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/elements/AccountHeader.vue').default,AccountNav: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/elements/AccountNav.vue').default,AccountBody: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/default/elements/AccountBody.vue').default})
